/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

var app = require('mag-app'),
    env;


// init environment for mag stb platform
if ( PLATFORM === 'MAG' ) {
    app.playerManager = require('../platforms/mag/stbPlayerManager');
    app.audioManager = require('../platforms/mag/stbAudioManager');
    env = {
        platform: 'MAG',
        playerCount: app.playerManager.list.length
    };

    app.audioManager.list[0].clear();
    app.audioManager.list[0].add(app.playerManager.list[0]);

} else if ( PLATFORM === 'TIZEN' ) {
    app.playerManager = require('../platforms/tizen/playerManager');
    app.audioManager = require('../platforms/audioManager-empty');
    env = {
        platform: 'TIZEN',
        playerCount: 1
    };
} else if ( PLATFORM === 'WEBOS' ) {
    app.playerManager = require('../platforms/webos/playerManager');
    app.audioManager = require('../platforms/audioManager-empty');
    env = {
        platform: 'WEBOS',
        playerCount: 1
    };
} else if ( PLATFORM === 'SMARTTV' ) {
    app.playerManager = require('../platforms/smart-tv/playerManager');
    app.audioManager = require('../platforms/audioManager-empty');
    env = {
        platform: 'SMART-TV',
        playerCount: 1
    };
}

module.exports = env;
